"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { SingleWaveDropContentMetadata } from "./SingleWaveDropContentMetadata";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WaveDropContent from "../drops/WaveDropContent";
import { ImageScale } from "@/helpers/image.helpers";
interface SingleWaveDropContentProps {
  readonly drop: ExtendedDrop;
}
export const SingleWaveDropContent: React.FC<SingleWaveDropContentProps> = t0 => {
  const $ = _c(8);
  const {
    drop
  } = t0;
  const [activePartIndex, setActivePartIndex] = useState(0);
  let t1;
  if ($[0] !== activePartIndex || $[1] !== drop) {
    t1 = <WaveDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onLongPress={_temp} onQuoteClick={_temp2} setLongPressTriggered={_temp3} mediaImageScale={ImageScale.AUTOx1080} />;
    $[0] = activePartIndex;
    $[1] = drop;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== drop) {
    t2 = !!drop.metadata.length && <SingleWaveDropContentMetadata drop={drop} />;
    $[3] = drop;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="tw-mb-4 tw-flex tw-flex-col tw-gap-y-4">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
function _temp() {}
function _temp2() {}
function _temp3() {}